import { render, staticRenderFns } from "./BaseProductSeriesConfigurationItem.vue?vue&type=template&id=3ff5cc70&scoped=true"
import script from "./BaseProductSeriesConfigurationItem.vue?vue&type=script&lang=js"
export * from "./BaseProductSeriesConfigurationItem.vue?vue&type=script&lang=js"
import style0 from "./BaseProductSeriesConfigurationItem.vue?vue&type=style&index=0&id=3ff5cc70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5cc70",
  null
  
)

export default component.exports